import axios from "axios";

const client = axios.create();
const getAccessToken = () => localStorage.getItem("accessToken");
const getTokenType = () => localStorage.getItem("tokenType");

client.interceptors.request.use(
  config => ({
    ...config,
    headers: {
      ...config.headers,
      Authorization: `${getTokenType()} ${getAccessToken()}`
    }
  }),
  error => Promise.reject(error)
);

client.interceptors.response.use(
  response => response,
  error => {
    // if not authenticated, throw away access token and reload page to get a fresh one
    if (error.response.status === 401) {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("tokenType");
      // eslint-disable-next-line no-restricted-globals
      location.reload();
    }

    return Promise.reject(error);
  }
);

export default client;
